import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function CommonStyles() {
  return (
    <style jsx>{`
      .container {
        max-width: 960px;
        margin: 0 auto;
        padding: 20px;
        line-height: 1.5;
        font-size: 15px;
        font-family: "FreeSans", sans-serif;
        color: #222;
      }

      header h1 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 700;
      }

      .text p {
        margin-bottom: 1em;
        font-size: 0.95rem;
        color: #333;
      }

      h2 {
        margin-top: 2.5em;
        font-size: 1.8rem;
        font-weight: 600;
      }

      

      .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 16px;
        margin-top: 32px;
      }

      img {
        width: 100%;
        transition: transform 0.3s ease;
      }

      img:hover {
        transform: scale(1.03);
      }

     .back-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
        }

        .back-button button {
          background: #000;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 0.9rem;
          border: none;
          cursor: pointer;
          transition: opacity 0.25s ease;
        }

        .back-button button:hover {
          opacity: 0.8;
        }

.lang-switch {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lang-switch button {
  background: #000;
  color: #fff;
  padding: 5px 12px;        /* identisch */
  border-radius: 6px;       /* identisch */
  font-size: 0.8rem;        /* identisch */
  border: none;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.lang-switch button:hover {
  opacity: 0.8;
}
    `}</style>
  );
}

export default function Timelines() {
  const [images, setImages] = useState([]);

useEffect(() => {
  const fetchImages = async () => {
    try {
      const res = await fetch("/data/timelines.json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
          "Pragma": "no-cache"
        }
      });

      if (!res.ok) {
        throw new Error("Fehler beim Laden von timelines.json");
      }

      const json = await res.json();
      setImages(json.images || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchImages();
}, []);

  return (
    <article className="container">
      <div className="lang-switch">
        <Link to="/Zeitlinien">
          <button>DE</button>
        </Link>
      </div>

      <header>
        <h1>TIMELINES</h1>
      </header>

      <section className="text">
        <p>At the center of<Link to="/ArchivEn"> Billi Thanner’s </Link> artistic practice lies the line as an elemental structure of space.</p>
        <p>Not as a graphic sign, but as a physical, time-based plane.</p>

        <p>
          Her light sculptures and installations investigate perception as an active process.
          Space does not appear as a static condition, but as a relational field –
          a configuration of movement, energy, observation, and interstitial space.
        </p>

        <p>
          In dialogue with contemporary field theories, Thanner understands reality as dynamic.
          The line functions as a temporal trace: it marks transitions, condensations, and superimpositions.
          Architecture is not supplemented, but transformed into an event.
        </p>

        <p>
          Light becomes a medium of visibility. Urban flows, frequencies, and movements –
          processes that normally remain unseen – manifest as linear energy fields.
        </p>

        <p>
          Like a reservoir of time, or a <Link to="/ArchivEn"> spatial memory archive </Link>,
          Thanner describes this dimension of her work.
        </p>

        <p>The line does not operate as a boundary, but as a threshold.</p>
        <p>Not as closure, but as passage.</p>

        <p>
          Her work operates within the tension between order and flux.
          Structure is not dissolved, but set into vibration.
          The line becomes a carrier of information – a code between site and viewer.
        </p>

        <p><strong>Her central question is:</strong></p>
        <p>
          What becomes visible once we develop the technical means
          to perceive our own traces in space?
        </p>

        <p>
          Within this practice, sculpture does not emerge as an object,
          but as a condition – a temporary constellation of light,
          architecture, perception, and the space in between.
        </p>

        <h2>Vertical Frequency</h2>

        <p><strong>Series Timelines, 2026</strong></p>
        <p>
          Dimensions:<br />
          16 individual modules, each 30 × 33 cm<br />
          1 central module, 65 × 71 cm
        </p>

        <p>
          In Vertical Frequency, the line is translated into modular light units.
          Multiple vertically aligned light bodies form a serial field
          that generates rhythm, pulse, and intensity.
        </p>

        <p>
          Each module functions as an autonomous impulse while simultaneously
          operating as part of a larger structure.
          Through repetition and minimal variation, an energetic grid emerges –
          one that does not fill space, but structures it.
        </p>

        <p>
          The vertical orientation condenses movement into upright tension.
          Light becomes measurable presence –
          a frequency oscillating between stability and vibration.
        </p>

        <p>
          Vertical Frequency understands sculpture as a system:
          a constellation of light, architecture, and perception
          that reorganizes itself with every shift in the viewer’s position.
        </p>
      </section>

      <section className="gallery">
        <div className="grid">
          {images.map((img, i) => (
            <figure key={i}>
              <img src={img.url} alt={img.alt || ""} loading="lazy" />
              {img.titleen && <figcaption>{img.titleen}</figcaption>}
            </figure>
          ))}
        </div>
      </section>

      <div className="back-button">
        <Link to="/">
          <button>back</button>
        </Link>
      </div>

      <CommonStyles />
    </article>
  );
}